import { render, staticRenderFns } from "./ColorIndicationTab.vue?vue&type=template&id=4f489ab7&scoped=true&"
import script from "./ColorIndicationTab.vue?vue&type=script&lang=js&"
export * from "./ColorIndicationTab.vue?vue&type=script&lang=js&"
import style0 from "./ColorIndicationTab.vue?vue&type=style&index=0&id=4f489ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f489ab7",
  null
  
)

export default component.exports